<template>
  <div
    :key="'btn-facebook' + componentKey"
    class="btn-facebook">
    <div
      class="fb-like"
      data-href="https://www.facebook.com/pocketcurator/"
      data-width=""
      data-layout="button"
      data-action="like"
      data-size="small"
      data-show-faces="true"
      data-share="false"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import setting from '@/setting.js'
export default {
  name: 'BtnFacebook',
  components: {
    setting,
    mapGetters
  },
  data () {
    return {
      setting,
      componentKey: 0,
      timer: null
    }
  },
  computed: {
    ...mapGetters(['textData', 'lang'])
  },
  methods: {
    createScript: function () {
      // 言語設定
      let langText = this.setting.facebookLangCode[this.lang.params]
      // sdk言語設定
      window.FB = null
      let fbRootElem = document.getElementById('fb-root')
      if (fbRootElem) fbRootElem.remove()
      let sdkElem = document.getElementById('facebook-jssdk')
      console.log('sdkElem:', sdkElem)
      if (sdkElem) sdkElem.remove()
      // いいねボタン用のJSを作成
      let facebookScript = document.createElement('script')
      facebookScript.id = 'facebook-jssdk'
      facebookScript.async = true
      facebookScript.setAttribute('src', 'https://connect.facebook.net/' + langText + '/sdk.js#xfbml=1&version=v4.0&ver=' + this.componentKey)
      document.querySelector('.btn-facebook').appendChild(facebookScript)
    }
  },
  mounted () {
    console.log('facebook mounted')
    this.createScript()
  },
  updated () {
    console.log('facebook updated')
    this.createScript()
  },
  created () {
  },
  watch: {
    'lang': function () {
      this.componentKey++
    }
  }
}
</script>

<style lang="postcss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/atoms/BtnFacebook.vue